import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-testid"];
const _hoisted_2 = { class: "flex flex-wrap items-center justify-between gap-x-3 gap-y-1" };
const _hoisted_3 = ["for"];
import { InlineLink, TextInput } from "@eudonet/opal";
import { useId } from "vue";
import { RouterLink } from "vue-router";
import { WORKSPACE_SETTINGS_ROUTE_NAME } from "@/modules/workspace/public";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsReadOnlyField',
    props: {
        label: {},
        value: {},
        editable: { type: Boolean, default: true },
        testId: { default: undefined }
    },
    setup(__props) {
        // The label sits beside the edit link, outside the OPAL input, so the association is explicit.
        const inputId = useId();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col gap-1.5",
                "data-testid": __props.testId
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", {
                        for: _unref(inputId),
                        class: "text-sm font-medium text-(--colors-text-heading)"
                    }, _toDisplayString(__props.label), 9 /* TEXT, PROPS */, _hoisted_3),
                    (__props.editable)
                        ? (_openBlock(), _createBlock(_unref(InlineLink), {
                            key: 0,
                            as: _unref(RouterLink),
                            to: { name: _unref(WORKSPACE_SETTINGS_ROUTE_NAME) },
                            "icon-left": "ri-pencil-line",
                            "aria-label": `${__props.label} – ${_ctx.$t('finance.taxReceipts.settings.editInWorkspaceSettings')}`,
                            class: "-my-2 -mr-3",
                            "data-testid": __props.testId ? `${__props.testId}-edit` : undefined
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("finance.taxReceipts.settings.editInWorkspaceSettings")), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["as", "to", "aria-label", "data-testid"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createVNode(_unref(TextInput), {
                    id: _unref(inputId),
                    "model-value": __props.value,
                    placeholder: _ctx.$t('finance.taxReceipts.settings.notProvided'),
                    readonly: "",
                    "full-width": ""
                }, null, 8 /* PROPS */, ["id", "model-value", "placeholder"])
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
